module.exports = __webpack_public_path__ + "static/media/icon_settings.b30c6b17.svg";